import { render, staticRenderFns } from "./filter-list.vue?vue&type=template&id=1d3497ea&scoped=true&lang=pug&"
import script from "./filter-list.vue?vue&type=script&lang=ts&"
export * from "./filter-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3497ea",
  null
  
)

export default component.exports